import { commonProps } from "../../commonTypes";

export const filteredQuestionIds = (
  allQuestionIds: string[],
  questionObjVariable: commonProps["Question"]["questionObj"],
  dependencyAnsHash: Set<string>
) => {
  let updatedFilterData = allQuestionIds?.filter((quesId) => {
    // Check if the question is derivative
    if (questionObjVariable[quesId]?.isDerivative) {
      // If the question is derivative, return false immediately
      return false;
    }
    // If the question is not derivative, proceed with other checks
    if (!questionObjVariable[quesId]?.dependentOn?.length) {
      // If the question has no dependencies, it should be visible
      return true;
    }
    // If the question has dependencies, check if any dependency is satisfied
    for (let optionIds of questionObjVariable[quesId]?.dependentOn) {
      if (dependencyAnsHash?.has(optionIds)) {
        // If a dependency is satisfied, return true
        return true;
      }
    }
    // If no dependencies are satisfied, return false
    return false;
  });

  return updatedFilterData;
};
